import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePermissions } from '../../hooks/usePermissions';
import { LoadingComponent } from '../../../components/loading/loading-component';

export function ProtectedRoute({ children, resource, requiredPermission }: { children: React.ReactNode; resource?: string; requiredPermission?: 'lecture' | 'modification' | 'suppression' | 'creation' }) {
    const { user, loading } = useAuth();
    const { hasPermission } = usePermissions();
    const location = useLocation();

    if (loading) return <LoadingComponent />;

    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

    if (requiredPermission && resource && !hasPermission(resource, requiredPermission)) {
        return <Navigate to="/forbidden" replace />;
    }

    return <>{children}</>;
}
